<template>
  <LayoutSearchFieldVertical
    display-variant="list"
  >
    <div class="facet-buttons facet-mobile-grid">
      <button
        class="fb-button"
        v-for="c in contentsCode"
        :class="{
          'is-0': count(c) === 0,
          'is-selected': isSelected('+' + c),
        }"
        @click="select(c)"
        :key="c"
      >
        <span class="fb-label">{{ ls(contentsCodeLang[c]) }}</span>
        <span class="fb-count" :title="num(count(c))">{{
          facetNum(count(c))
        }}</span>
      </button>
    </div>
  </LayoutSearchFieldVertical>
</template>
<script lang="ts" setup>
import { useSearchFieldBase } from '~/components/search/search-field/useBaseSearchField'
import type { SearchFieldBaseProps } from '~/components/search/search-field/useBaseSearchField'

const { ls, num } = useI18n()
const { $getContentsCode, $getContentsCodeLang } = useNuxtApp()

interface Props extends SearchFieldBaseProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const { facet, facetNum } = useSearchFieldBase(props)

const contentsCode: string[] = $getContentsCode()
const contentsCodeLang: {} = $getContentsCodeLang()

function count(code) {
  if (!facet.value) return undefined
  return facet.value.counts[code] || 0
}

const select = (code: string) => {
  code = '+' + code
  if (isSelected(code)) {
    props.ss.removeFilter(props.field.key, [code])
  } else {
    props.ss.addFilter(props.field.key, [code])
  }
}

const isSelected = (code: string) => {
  return props.ss.state.filter[props.field.key]?.includes(code)
}
</script>
